import React, { forwardRef, useContext, isValidElement } from 'react';
import styles from '../Input.module.css';
import { InputContext } from '../Input';
import { altoConsole } from '../../../../utils/console/console';

interface SelectProps {
  children: React.ReactElement;
  className?: string;
}

const InputStartSelect = forwardRef<HTMLDivElement, SelectProps>(
  ({ children, className }, ref) => {
    const state = useContext(InputContext);

    // Validate that only select element is passed
    const isSelectElement =
      isValidElement(children) &&
      (children.type === 'select' ||
        (typeof children.type === 'string' &&
          children.type.toLowerCase() === 'select'));

    if (!isSelectElement) {
      altoConsole.error('Input.StartSelect only accepts a select element', {
        scope: 'Input',
      });
    }

    return (
      <div
        ref={ref}
        className={`
          ${styles['input-field__startSelect']} 
          ${className || ''}
        `}
        {...(state.isDisabled ? { 'data-disabled': true } : {})}
        {...(state.isInvalid ? { 'data-invalid': true } : {})}
      >
        {React.cloneElement(
          children as React.ReactElement<
            React.SelectHTMLAttributes<HTMLSelectElement>
          >,
          {
            disabled: state.isDisabled,
            onFocusCapture: () => {
              if (ref && 'current' in ref && ref.current) {
                ref.current.dataset.focused = 'true';
                ref.current.dataset.focusVisible = 'true';
              }
            },
            onBlurCapture: () => {
              if (ref && 'current' in ref && ref.current) {
                delete ref.current.dataset.focused;
                delete ref.current.dataset.focusVisible;
              }
            },
          },
        )}
      </div>
    );
  },
);
InputStartSelect.displayName = 'Input.StartSelect';

export default InputStartSelect;
